import { Typography } from '@design-system/components/typography/typography';
import { Tag } from '@design-system/components/tag/tag';
import { Button } from '@design-system/components/button/button';
import { ExternalLink } from '@design-system/components/link/externalLink';
import {
  buttonsWrapper,
  headerWrapper,
  learnMore,
  tag,
  wrapper,
} from './ExclusiveOfferPlaceholderCard.css';

export const ExclusiveOfferPlaceholderCard = ({
  create,
}: {
  create: () => void;
}) => (
  <div className={wrapper}>
    <div className={headerWrapper}>
      <Typography variant="headline" size="medium">
        Exclusive Subscription
      </Typography>
      <Tag label="Not set up" className={tag} readonly={true} />
    </div>
    <Typography variant="body" size="medium" fontWeight="normal">
      A second tier you control: pick the price, the perks, and exactly who gets
      access.
    </Typography>
    <div className={buttonsWrapper}>
      <Button color="neutral" onClick={create}>
        Start Exclusive Subscription
      </Button>
      <div className={learnMore}>
        <ExternalLink
          noDecoration
          textColor="P-80"
          textVariant="body"
          textSize="large"
          label="Learn more"
          href="https://help.playbookapp.io/en/articles/13621806-how-to-turn-on-an-exclusive-subscription"
        />
      </div>
    </div>
  </div>
);
